import cn from "classnames";
import { Link, Navigate } from "react-router-dom";

import { CANDIDATE_ROUTE, LOGIN_ROUTE } from "@/routing/AppRouter/routes.constants";

import buttonStyle from "@/ui-components/commonComponents/Button/style.module.css";

import style from "./style.module.css";

const MainPage = () => {
  if (process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== "test") {
    return <Navigate to={`/${CANDIDATE_ROUTE}/${LOGIN_ROUTE}`} replace={true} />;
  }

  return (
    <div className={style.container}>
      <div className={style.content}>
        <h1>THIS IS THE MAIN PAGE</h1>
        <div className={style.buttonGroup}>
          <div className={style.buttonContainer}>
            <Link to={LOGIN_ROUTE} className={cn(buttonStyle.linkAsButton, buttonStyle.linkAsButtonPrimary)}>
              Sign in as staff
            </Link>
          </div>
          <div className={style.buttonContainer}>
            <Link
              to={`/${CANDIDATE_ROUTE}/${LOGIN_ROUTE}`}
              className={cn(buttonStyle.linkAsButton, buttonStyle.linkAsButtonPrimary)}
            >
              Sign in as candidate
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MainPage };
